export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative min-h-screen flex items-end pb-20 md:pb-28 pt-16 md:pt-20 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/cd713296f5a6ba65a917655e661d1a74.jpg"
          alt="Immobilien NRW"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/20"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/20"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm border border-white/20 text-white text-xs font-semibold px-4 py-2 rounded-full mb-6">
            <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse inline-block"></span>
            NRW-weit tätig · 50+ Mitarbeiter im Einsatz
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-5" style={{ fontFamily: "'Satoshi', 'Inter', sans-serif" }}>
            Ihr Rundum-Service<br />
            <span className="text-white/70 font-normal">für Immobilien in NRW.</span>
          </h1>

          <p className="text-base md:text-lg text-white/75 leading-relaxed mb-8 max-w-lg">
            Reinigung, Hausmeister, Grünpflege &amp; Sanierung – alles aus einer Hand.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-10">
            <button
              onClick={() => scrollTo("kontakt")}
              className="bg-white text-black font-semibold px-7 py-4 rounded-full hover:bg-gray-100 transition-all cursor-pointer whitespace-nowrap flex items-center gap-2 justify-center"
            >
              <i className="ri-calendar-check-line"></i>
              Kostenloses Erstgespräch anfragen
            </button>
            <button
              onClick={() => scrollTo("kontakt")}
              className="border-2 border-white text-white font-semibold px-7 py-4 rounded-full hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap flex items-center gap-2 justify-center"
            >
              <i className="ri-phone-line"></i>
              Rückruf in 24h sichern
            </button>
          </div>

          {/* Trust Bar */}
          <div className="flex flex-wrap gap-4 mb-8">
            {[
              "50+ Mitarbeiter im Einsatz",
              "NRW-weit tätig",
              "Kurzfristige Einsätze möglich",
            ].map((item) => (
              <div
                key={item}
                className="flex items-center gap-2 bg-white/15 backdrop-blur-sm border border-white/20 text-white text-sm px-4 py-2 rounded-full"
              >
                <i className="ri-check-line text-green-400 font-bold"></i>
                {item}
              </div>
            ))}
          </div>

          {/* TrustLocal Award Badges */}
          <div className="flex flex-col gap-2">
            <div className="flex items-center gap-2">
              <span className="text-white/50 text-xs font-semibold tracking-widest uppercase">Ausgezeichnet von</span>
              <a
                href="https://trustlocal.de/nordrhein-westfalen/ratingen/reinigungsfirma/amaterasu-facility/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="flex items-center gap-1 text-white/40 hover:text-white/70 transition-colors cursor-pointer"
              >
                <span className="text-xs font-medium">TrustLocal</span>
                <i className="ri-external-link-line text-xs"></i>
              </a>
            </div>
            <div className="flex flex-wrap gap-2">
              {[
                { year: "2022", type: "Top Pro", icon: "ri-trophy-line", color: "from-amber-500/30 to-amber-600/20", border: "border-amber-400/40", text: "text-amber-300" },
                { year: "2024", type: "Top Score", icon: "ri-star-line", color: "from-yellow-400/30 to-yellow-500/20", border: "border-yellow-300/40", text: "text-yellow-200" },
                { year: "2024", type: "Top Pro", icon: "ri-trophy-line", color: "from-amber-500/30 to-amber-600/20", border: "border-amber-400/40", text: "text-amber-300" },
                { year: "2024", type: "Top Score", icon: "ri-star-line", color: "from-yellow-400/30 to-yellow-500/20", border: "border-yellow-300/40", text: "text-yellow-200" },
              ].map((badge, i) => (
                <div
                  key={i}
                  className={`flex items-center gap-2 bg-gradient-to-br ${badge.color} backdrop-blur-sm border ${badge.border} px-3 py-1.5 rounded-xl`}
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className={`${badge.icon} ${badge.text} text-sm`}></i>
                  </div>
                  <div className="flex flex-col leading-none">
                    <span className={`text-xs font-bold ${badge.text} whitespace-nowrap`}>{badge.type}</span>
                    <span className="text-white/50 text-xs">{badge.year}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-1 text-white/50">
        <span className="text-xs tracking-widest uppercase">Mehr erfahren</span>
        <i className="ri-arrow-down-line animate-bounce text-lg"></i>
      </div>
    </section>
  );
}
